export default __webpack_public_path__ + "media/images/home/hero/xl-4e4414fe4a9a047f9d65bbecd52bf158.webp";